import { pushEvent } from '../../googleTagManager/googleTagManagerUtils';

import { TGoogleAnalyticsEcommerceData } from './ecommerceTypes';

export const pushViewItemListEvent = (
	ecommerceData: TGoogleAnalyticsEcommerceData
): void => {
	pushEvent({
		event: 'view_item_list',
		ecommerce: ecommerceData,
	});
};

export const pushAddToCartEvent = (
	ecommerceData: TGoogleAnalyticsEcommerceData
): void => {
	pushEvent({
		event: 'add_to_cart',
		ecommerce: ecommerceData,
	});
};

export const pushBeginCheckoutEvent = (
	ecommerceData: TGoogleAnalyticsEcommerceData
): void => {
	pushEvent({
		event: 'begin_checkout',
		ecommerce: ecommerceData,
	});
};

export const pushPurchaseEvent = (
	ecommerceData: TGoogleAnalyticsEcommerceData
): void => {
	pushEvent({
		event: 'purchase',
		ecommerce: ecommerceData,
	});
};
